/**
 * QA opt-out for the inline SVG sprite (see components/SvgSprite).
 *
 * The sprite is the default rendering path for `.svg` sources of the shared `Image`
 * component. To compare against the plain `<img>` path in the same build, run
 * `localStorage.setItem('lobby.svgSprite', '0')` and reload; remove the key to opt back in.
 * Read once per page load.
 */
const STORAGE_KEY = 'lobby.svgSprite';

let enabled: boolean | undefined;

export const isSvgSpriteEnabled = (): boolean => {
  if (enabled !== undefined) return enabled;
  try {
    enabled = typeof window === 'undefined' || window.localStorage.getItem(STORAGE_KEY) !== '0';
  } catch {
    enabled = true;
  }
  return enabled;
};
